import { DisplayHeading, Eyebrow, MUTED, Reveal } from '../Landing/ui';

export default function BlogHeader() {
  return (
    <div className="tw-relative tw-overflow-hidden tw-bg-[#FAF8F1] dark:tw-bg-[#0E1A16]">
      {/* Faint contour lines matching the post page atmosphere */}
      <svg
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-full tw-w-full tw-text-[#1D2D28] tw-opacity-[0.04] dark:tw-text-[#EBE6D9] dark:tw-opacity-[0.05]"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 800 300"
      >
        <g fill="none" stroke="currentColor" strokeWidth="1.2">
          <path d="M-40 60c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 120c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 220c135-60 255 45 375 0s200-75 345-20 160 60 160 60" />
        </g>
      </svg>

      <div className="tw-relative tw-mx-auto tw-max-w-2xl tw-px-4 tw-py-14 tw-text-center sm:tw-py-20">
        <Reveal>
          <Eyebrow>TravelFeed Journal</Eyebrow>
          <DisplayHeading
            as="h1"
            className="tw-text-4xl sm:tw-text-5xl lg:tw-text-[3.25rem]"
          >
            Travel Blogging
            <br />
            <em className="tw-italic tw-font-medium tw-text-primary-700 dark:tw-text-primary-300">
              Tips &amp; Tricks
            </em>
          </DisplayHeading>
          <p
            className={`${MUTED} tw-mx-auto tw-mb-0 tw-mt-5 tw-max-w-xl tw-text-lg tw-leading-relaxed`}
          >
            From inspiration to publication — guides, tools and stories to help
            travel bloggers start, manage and grow their adventures online.
          </p>
        </Reveal>
      </div>
    </div>
  );
}
